import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Badge } from '@companycam/slab-web';

const getFontSize = (size) => {
  if (size === 'small') {
    return 16;
  } else if (size === 'medium') {
    return 17;
  } else {
    return 21;
  }
};

const CircleBadge = styled(Badge)`
  padding: 0;
  width: ${({ size }) => getFontSize(size)}px;
  height: ${({ size }) => getFontSize(size)}px;
  align-items: center;
`;

const Icon = styled.i`
  font-size: ${(props) => getFontSize(props.size) - 3}px;
`;

const UpgradeIcon = ({ size, className, style, dataTestId }) => {
  return (
    <CircleBadge
      color="upgrade"
      className={className}
      size={size}
      style={{
        padding: 0,
        lineHeight: 0,
        height: getFontSize(size),
        width: getFontSize(size),
        ...style,
      }}
      data-testid={dataTestId}
    >
      <Icon size={size} className="mdi mdi-lightning-bolt upgrade-icon" />
    </CircleBadge>
  );
};

UpgradeIcon.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
  style: PropTypes.object,
  dataTestId: PropTypes.string,
};

UpgradeIcon.defaultProps = {
  size: 'medium',
  className: undefined,
  style: undefined,
};

export default UpgradeIcon;
